/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=25b42f92&scoped=true&"
import script from "./Index.vue?vue&type=script&setup=true&lang=js&"
export * from "./Index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=25b42f92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b42f92",
  null
  
)

export default component.exports